import { FormattedMessage, useIntl } from "react-intl";
import { ActivityIndicator } from "react-native";
import Text from "@ticketingplatform/ui/dist/components/styles/Typography";
import Input from "@ticketingplatform/ui/dist/components/atoms/Fields/Input";
import { useEventOccurrence } from "views/EventDetails/hooks";
import EventHeading from "views/EventDetails/partials/EventHeading";
import { Flex } from "components/styles";
import { useDebouncedValue } from "hooks/useDebouncedValue";
import hasEvent from "utils/hasEvent";

import TicketFlatList from "./partials/TicketList";
import { useTicketList } from "./hooks";

const TicketList: React.FC = () => {
  const intl = useIntl();
  const { eventOccurrence, loading } = useEventOccurrence();
  const [searchValue, debouncedSearch, onSearch] = useDebouncedValue("", 1000);
  const ticketList = useTicketList(debouncedSearch);

  if (loading) {
    return <ActivityIndicator />;
  }

  if (!eventOccurrence || !hasEvent(eventOccurrence)) {
    return (
      <Text textAlign="center" margin="2rem">
        <FormattedMessage defaultMessage="Event not found" />
      </Text>
    );
  }

  return (
    <Flex padding="0.5rem" flexDirection="column" height="100%">
      <EventHeading {...eventOccurrence} />
      <Input
        variant="secondary"
        placeholder={intl.formatMessage({
          defaultMessage: "Search for a guest",
        })}
        value={searchValue}
        onChange={({ target: { value } }) => onSearch(value)}
      />
      <TicketFlatList {...ticketList} />
    </Flex>
  );
};

export default TicketList;
